import { Injectable } from "@angular/core";
import { RouteUtils } from "../_helpers/route-utility-tool";
import { ActivatedRouteSnapshot } from "@angular/router";
import { IUrlParamsKey } from "@vision/viewer-components";

@Injectable({
  providedIn: "root",
})
export class UrlParametersService {
  getLoginParameters(route: ActivatedRouteSnapshot) {
    const loginUrlParamsKey: IUrlParamsKey = RouteUtils.getUrlParamKeys(
      route.queryParamMap.keys,
    );

    const {
      tokenURLKey,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      api_keyURLKey,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      impersonation_keyURLKey,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      geo_keyURLKey,
    } = loginUrlParamsKey;

    let loginParams = [];

    const token = route.queryParamMap.get(tokenURLKey) || null;
    const apiKey = route.queryParamMap.get(api_keyURLKey) || null;
    const impersonationKey =
      route.queryParamMap.get(impersonation_keyURLKey) || null;
    const geoKey = route.queryParamMap.get(geo_keyURLKey) || null;

    if (token) {
      loginParams = [tokenURLKey, token];
    }

    if (apiKey) {
      loginParams = [api_keyURLKey, apiKey];
    }

    if (impersonationKey) {
      loginParams = [impersonation_keyURLKey, impersonationKey];
    }

    if (geoKey) {
      loginParams = [geo_keyURLKey, geoKey];
    }

    return loginParams;
  }

  getUrlParameters(route: ActivatedRouteSnapshot) {
    const urlParamsKey: IUrlParamsKey = RouteUtils.getUrlParamKeys(
      route.queryParamMap.keys,
    );

    const {
      latitudeURLKey,
      longitudeURLKey,
      zoomURLKey,
      addressURLKey,
      state1URLKey,
      state2URLKey,
    } = urlParamsKey;

    // not logged in so redirect to login page with the return url
    const lat = latitudeURLKey ? route.queryParamMap.get(latitudeURLKey) : null;
    const long = longitudeURLKey
      ? route.queryParamMap.get(longitudeURLKey)
      : null;
    const zoom = zoomURLKey ? route.queryParamMap.get(zoomURLKey) : null;
    const address = addressURLKey
      ? route.queryParamMap.get(addressURLKey)
      : null;

    const state1 = route.queryParamMap.get(state1URLKey);
    const state2 = route.queryParamMap.get(state2URLKey);

    const queryParams = {
      [latitudeURLKey]: lat,
      [longitudeURLKey]: long,
      [zoomURLKey]: zoom,
      [addressURLKey]: address,
    };

    if (state1) {
      queryParams[state1URLKey] = state1;
    }
    if (state2) {
      queryParams[state2URLKey] = state2;
    }

    return queryParams;
  }
}
